/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ConnectAtlasOrganizationRequest {
  /**
  * Optional custom display name for the organization.
  */
  'name'?: string;
  /**
  * The MongoDB Atlas API public key.
  */
  'apiPublicKey': string;
  /**
  * The MongoDB Atlas API private key.
  */
  'apiPrivateKey': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "apiPublicKey",
      "baseName": "apiPublicKey",
      "type": "string",
      "format": ""
    },
    {
      "name": "apiPrivateKey",
      "baseName": "apiPrivateKey",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ConnectAtlasOrganizationRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

